var map = {
	"./1280x720.jpg": 51,
	"./1920x1080.jpg": 52,
	"./200x200.jpg": 53,
	"./3840x2160.jpg": 54,
	"./4500x3000.jpg": 55,
	"./5463x3418.jpg": 56,
	"./720x480.jpg": 57,
	"./7680x4320.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;